// Page
export const SET_PAGE_LOADING = 'SET_PAGE_LOADING';

// Viewport
export const SET_VIEWPORT = 'SET_VIEWPORT';
export const SET_PAGE_VISIBILITY = 'SET_PAGE_VISIBILITY';

// Side navitation
export const TOGGLE_SIDE_NAVIGATION = 'TOGGLE_SIDE_NAVIGATION';

// Services
export const SET_SERVICES = 'SET_SERVICES';
export const SET_AVAILABLE_SERVICE_FILTERS = 'SET_AVAILABLE_SERVICE_FILTERS';
export const SET_ACTIVE_SERVICE_FILTERS = 'SET_ACTIVE_SERVICE_FILTERS';
export const SET_SERVICES_DEFAULTS = 'SET_SERVICES_DEFAULTS';
export const SET_SERVICES_API_ERROR = 'SET_SERVICES_API_ERROR';
export const SET_IS_LOADING_SERVICES = 'SET_IS_LOADING_SERVICES';
export const SET_SERVICE_QUERY = 'SET_SERVICE_QUERY';

// Insights
export const SET_INSIGHTS = 'SET_INSIGHTS';
export const RESET_INSIGHTS = 'RESET_INSIGHTS';
export const SET_AVAILABLE_INSIGHT_FILTERS = 'SET_AVAILABLE_INSIGHT_FILTERS';
export const SET_ACTIVE_INSIGHT_FILTERS = 'SET_ACTIVE_INSIGHT_FILTERS';
export const SET_INSIGHTS_API_ERROR = 'SET_INSIGHTS_API_ERROR';
export const SET_IS_LOADING_INSIGHTS = 'SET_IS_LOADING_INSIGHTS';
export const SET_LOADING_MORE_INSIGHTS = 'SET_LOADING_MORE_INSIGHTS';
export const SET_INSIGHT_QUERY = 'SET_INSIGHT_QUERY';

// User region
export const SET_USER_REGION = 'SET_USER_REGION';
